import 'date-fns'
import React from 'react'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  DateTimePicker
} from '@material-ui/pickers'
import CalendarIcon from '@material-ui/icons/CalendarToday'
import { IconButton, InputAdornment } from '@material-ui/core'
import { createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/styles'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#03B0EE',
      contrastText: '#FFF',
    },
  },
  typography: { useNextVariants: true },
})

export default props => {
  const {
    onChange,
    minDate,
    value,
    label,
    format,
  } = props

  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DateTimePicker
          style={{ width: '100%' }}
          autoOk
          ampm={false}
          value={value ? new Date(value) : null}
          onChange={val => onChange({ target: { value: val.toJSON() } })}
          allowKeyboardControl={false}
          minDate={minDate}
          label={label}
          format={format || 'dd/MM/yyyy'}
          leftArrowButtonProps={{ 'aria-label': 'mes anterior' }}
          rightArrowButtonProps={{ 'aria-label': 'mes siguiente' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton>
                  <CalendarIcon />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}